export const styles = {
  tooltip: {
    maxWidth: '500px',
  },
  cardWrapper: ({ palette }) => ({
    backgroundColor: palette.accentFade.main,
    borderRadius: 2,
    minHeight: 152,
    padding: 2,
    border: 0,
    transition: 'none',
    boxShadow: '0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)',
  }),
};
